import { Popover } from "@headlessui/react";
import { IUserInfoProps } from "../user-info/type";
import { UserInfo } from "../user-info";
import styled from "styled-components";
import { useState, useRef } from "react";
import { usePopper } from "react-popper";

export function ProfilePopover({ userInfo, ...props }: IUserInfoProps) {
  let [referenceElement, setReferenceElement] = useState<HTMLElement>();
  let [popperElement, setPopperElement] = useState<HTMLElement>();
  const [show, setShow] = useState(true);
  let { styles, update } = usePopper(referenceElement, popperElement, {
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 5],
        },
      },
    ],
  });
  const buttonRef = useRef();
  const click = () => buttonRef.current?.click();
  const handleMouse = (isShow) => {
    if (!isShow) {
      click();
      return;
    }
    isShow && !show && click();
    setShow(isShow);
  };

  return (
    <PopoverWrapper
      onMouseOver={() => handleMouse(true)}
      ref={(html: HTMLElement) => {
        html && setReferenceElement(html);
      }}
    >
      <Popover.Button
        as={"span"}
        ref={buttonRef}
        onMouseEnter={() => handleMouse(false)}
        onClick={() => buttonRef.current?.click()}
      >
        {/* <>{userInfo.userName?.[0].toUpperCase()}</> */}
      </Popover.Button>

      <Popover.Panel
        onMouseLeave={() => handleMouse(false)}
        ref={(c: HTMLDivElement) => c && setPopperElement(c)}
        style={{ zIndex: 1, ...styles.popper }}
      >
        {({ close }) => (
          <UserProfileWrapper>
            <UserInfo userInfo={userInfo} close={close} {...props} />
          </UserProfileWrapper>
        )}
      </Popover.Panel>
    </PopoverWrapper>
  );
}

const UserProfileWrapper = styled.div`
  padding-top: 48px;
  margin-top: -48px;
  width: 116px;
  position: relative;
  > div {
    position: absolute;
    /* left: 0;
    transform: translate(-60%, 0); */
    right: 0;
  }
`;

const PopoverWrapper = styled(Popover)`
  line-height: 1;
  width: 100%;
  height: 100%;
  cursor: unset;
  > span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
`;
